export default "__VITE_ASSET__DLqa8oos__"